export enum Region {
    COSTA = "Costa",
    SIERRA = "Sierra",
    SELVA = "Selva",
}

export enum AccessLevel {
    FACIL = "Facil",
    MEDIANO = "Mediano",
    DIFICIL = "Dificil",
    MUY_DIFICIL = "MuyDificil",
}

export enum SizeCategory {
    XXS = "XXS",
    XS = "XS",
    S = "S",
    M = "M",
    L = "L",
}

export enum LimaZone {
    NORTE = "Norte",
    SUR = "Sur",
    ESTE = "Este",
    OESTE = "Oeste",
    CENTRO = "Centro",
    CALLAO = "Callao",
}